<template>
  <div class="mobile-slider">
    <div class="values" :style="{ transform: 'translateX(' + translate + 'px)' }" ref="values">
      <span v-for="(v, i) in values" :key="v" class="value" :class="{ centered: centered == i }" :style="getStyle(i)">{{ v }}</span>
    </div>
  </div>
</template>
<script>
import format from '@/utils/format.js'

const width = 85

export default {
  name: 'MobileSlider',
  props: {
    start: Number,
    values: Array
  },
  data () {
    return {
      centered: 0,
      translate: 0,
      active: false,
      startClientX: 0
    }
  },
  watch: {
  },
  created () {
    this.centered = this.values.indexOf(this.start)
    this.translate = -1 * (this.centered + 0.5) * width
  },
  filters: {
    formatValue: format.formatValue
  },
  mounted () {
    this.$refs.values.addEventListener('touchstart', this.handlePointerDown)
    document.addEventListener('touchend', this.handlePointerUp)
    document.addEventListener('touchcancel', this.handlePointerUp)
    document.addEventListener('touchmove', this.handlePointerMove)
    this.$refs.values.addEventListener('mousedown', this.handleMouseDown)
    document.addEventListener('mouseup', this.handleMouseUp)
    document.addEventListener('mousecancel', this.handleMouseUp)
    document.addEventListener('mousemove', this.handleMouseMove)
  },
  methods: {
    getStyle (index) {
      let dist = Math.abs(index - this.centered)
      return { opacity: Math.max(0, 1 - (dist * 0.25)) }
    },
    updateCentered () {
      let index = Math.round((this.translate * -1 / width) - 0.5)
      this.centered = Math.max(Math.min(index, this.values.length - 1), 0)
    },
    handlePointerDown (event) {
      this.active = true
      this.startClientX = (event.touches[0].clientX) - this.translate
      event.stopPropagation()
    },
    handlePointerUp (event) {
      if (!this.active) return
      this.active = false
      this.translate = -1 * (this.centered + 0.5) * width
      this.$emit('update', this.values[this.centered])
    },
    handlePointerMove (event) {
      if (!this.active) return
      this.translate = Math.max(Math.min((event.touches[0].clientX) - this.startClientX, 0), -1 * width * this.values.length)
      this.updateCentered()
    },
    handleMouseDown (event) {
      this.active = true
      this.startClientX = (event.clientX) - this.translate
      event.stopPropagation()
    },
    handleMouseUp (event) {
      if (!this.active) return
      this.active = false
      this.translate = -1 * (this.centered + 0.5) * width
      this.$emit('update', this.values[this.centered])
    },
    handleMouseMove (event) {
      if (!this.active) return
      this.translate = Math.max(Math.min((event.clientX) - this.startClientX, 0), -1 * width * this.values.length)
      this.updateCentered()
    }
  }
}
</script>
<style>
div.mobile-slider {
  width: 100%;
  overflow: hidden;
  position: relative;

}
div.mobile-slider > div.values {
  white-space: nowrap;
  position: relative;
  left: 50%;
}
div.mobile-slider > div.values > span {
  display: inline-block;
  font-size: 40px;
  width: 85px;
  text-align: center;
}
div.mobile-slider > div.values > span.centered {
  font-size: 63px;
}
</style>
